/** Created by azhou on 2019/1/16.*/
<template>
  <div class="d-flex align">
    <div class="align-nrk">
      <img :src="!_IsDevMode?'/images/public/guide_logo.png':'/images/public/guide_logo_1.png'" @click="$router.push('/')"/>
      <div class="d-center-between h6 member-wrap" v-if="!userLoginMessage.id&&!userLoginMessage.uid">
        <div class="login" @click="$router.push({name:'userLogin'})" >
          <i class="iconfont  icon-yonghudenglu"></i>登录
        </div>
        <div class="register" @click="$router.push({name:'identity'})" ><i class="el-icon-user"></i>注册</div>
        <!-- <a href="javascript:;" class="login" >登录/注册</a> -->
      </div>
      <div class="primary" v-if="userLoginMessage.token" >
        <div>
          <el-button   @click="$router.push({ name: 'CenterIndex'});" >返回</el-button>
          <el-button type="primary"  @click="logout">退出登录</el-button>
        </div>
        <!-- <a href="javascript:;" class="text-login">退出登录</a> -->
      </div>
      <!-- <h5 class="mr-5" v-if="userLoginMessage.token" v-show="type == '1'">
        <a href="javascript:;"  @click="$router.push({ name: 'regBasicClose'});" class="text-login">返回关联酒店</a>
      </h5> -->
      <!-- <h5 class="mr-5" v-if="userLoginMessage.token" v-show="type == '2'">
        <a href="javascript:;" @click="$router.push({ name: 'CenterIndex'});" class="text-login">返回</a>
      </h5> -->
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions,mapMutations } from 'vuex'

  export default {
    props: {
      type: {
        type: Number,
        default: 0
      }
    },
    computed: {
      ...mapState(['userLoginMessage','newMessageInform']),
    },
    watch: {
      //满足所有认证提交提醒提交认证操作
      allChecked (newVal) {
        if (newVal && this.storeInfo.verify === 0) this.setVerifyStatue()
      },
      //认证通过进行页面跳转
      newMessageInform (newVal) {
        if (newVal && newVal.type === 3) {
          //更新用户信息 
          this.updateInfo()
          if (newVal.verify == '1') {      //认证通过
            //管理员和集团账号时重新拉取门店信息
             this._alert('门店已认证通过！',() => {
              //审核通过清空注册门店信息
              this.UPDATECURRENTSTORE('clear');
              //跳转到选择酒店页面
              this.$router.push({name:'CenterIndex'}); 
            })
            // else this.$router.push('/userCenter')          //单门店身份自动跳转到会员中心
          } else this._alert('很遗憾，您的认证未通过，如有疑问请联系客服',this.getStoreInfo({store_id: this.userLoginMessage.submit_store_id}),'error')
        }
      },
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['logout','getStoreInfo','updateInfo'])
    }
  }
</script>
<style lang="scss" scoped>
  .align{
    background-color: #fff;
    overflow: hidden;
    width: 92%;
    padding:0 4%;
    margin-bottom: 100px;
    justify-content: space-between;
  }
  .primary{
    height: 80px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .align-nrk{
    margin: 0 auto;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    img{
      cursor: pointer;
      width: 180px;
      height: 60px;
      margin-top: 10px;
    }
  }
  .member-wrap {
    // max-width: 255px;
    margin-left: auto;
    span{
      vertical-align: middle
    }
    label{
      display: -webkit-box;
      vertical-align: middle;
      max-width: 85px!important;
      max-height: 60px;
      overflow: hidden;
      text-align: left;
      -webkit-line-clamp:1;
      -webkit-box-orient: vertical;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }
  }
    .login{
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px var(--smtc-color-primary) solid;
    background-color: var(--smtc-color-primary);
    color: #fff;
    box-shadow: 0 2px 4px #eee;
    cursor: pointer;
    i{
      margin-right: 6px;
      font-size: 14px;
    }
  }
  .login:hover{
    background-color: var(--smtc-color-primary-hover);
  }
  .register{
    padding: 8px 12px;
    border-radius: 8px;
    margin-left: 10px;
    cursor: pointer;
    i{
      margin-right: 6px;
      font-size: 14px;
    }
  }
</style>
